import React from 'react';
import AllItemsPage from 'core/views/admin/AllItemsPage';

const AllItems = () => <AllItemsPage />;

export default AllItems;
